import React from 'react';
import { Zoom, Fab } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';

export default function ScrollTopButton({ show, onClick }) {
    return (
        <Zoom in={show}>
            <Fab
                size="small"
                color="primary"
                onClick={onClick}
                sx={{
                    position: 'fixed',
                    bottom: 24,
                    right: 32,
                    zIndex: 9999
                }}
            >
                <KeyboardArrowUp />
            </Fab>
        </Zoom>
    );
}
